// src/components/SpecialBallOverlay.js
import React, { useEffect } from 'react';
import './SpecialBallOverlay.css'; // We'll create this CSS file next

function SpecialBallOverlay({ onClose }) {
  // IMPORTANT: How to use your local image:
  // 1. Place your image file (e.g., 'o69-image.webp' or 'o69-image.gif')
  //    inside the 'public' folder.
  // 2. The `src` attribute below will automatically look in the 'public' folder.
  const imgSrc = "/O69.webp"; // Path relative to the public folder (use your actual filename)

  // Auto-close after a few seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 4000); // Adjust duration as needed (4000ms = 4 seconds)

    return () => clearTimeout(timer); // Cleanup timer on component unmount
  }, [onClose]);

  // Create confetti elements
  const confettiElements = Array.from({ length: 50 }).map((_, index) => (
    <div
      key={index}
      className="confetti"
      style={{
        left: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 2}s`,
        backgroundColor: `hsl(${Math.random() * 360}, 100%, 70%)`, // Random bright colors
        transform: `rotate(${Math.random() * 360}deg) scale(${Math.random() * 0.5 + 0.5})`,
      }}
    />
  ));

  return (
    // Overlay container - clicking it will also close, in addition to auto-close
    <div className="special-ball-overlay" onClick={onClose}>
      <div className="special-ball-content" onClick={(e) => e.stopPropagation()}>
        <div className="special-ball-image-container">
          <img src={imgSrc} alt="Special Ball O-69!" />
        </div>
        <div className="confetti-container">
          {confettiElements}
        </div>
      </div>
    </div>
  );
}

export default SpecialBallOverlay;
